export default (function (w, d) {
    'use strict';

    function Header() {
        this.initDropdown();
        this.initMiniCartButtons();
        this.initMobileMenu();
        this.initStickyHeader();
        this.initLangDropdowns();
        this.initTopBarToggle();
        this.initProfileMenu();
        this.initMobileProfileMenu();
        this.initAdjustOnScroll();
    }

    Header.prototype.initDropdown = function () {
        const headerDropdownButtons = document.querySelectorAll('.header .dropdown');
        headerDropdownButtons.forEach(function (element) {
            element.addEventListener('mouseenter', function () {
                const dropdownId = element.dataset.dropdownId;
                const dropdownOverlay = document.querySelector('.header .dropdown-overlay[data-id="' + dropdownId + '"]');
                const otherDropdownOverlays = document.querySelectorAll('.header .dropdown-overlay:not([data-id="' + dropdownId + '"])');
                const otherDropdownButtons = document.querySelectorAll('.header .dropdown:not([data-dropdown-id="' + dropdownId + '"])');
                const brandsSlider = dropdownOverlay.querySelector('.brands-slider:not(.slick-initialized)');

                if (brandsSlider !== null) {
                    $('.brands-slider').slick({
                        focusOnSelect: false,
                        slidesToShow: 4,
                        infinite: false,
                        prevArrow: "",
                        nextArrow: "<button class='clickable slider-next' type='button'></button>",
                    });

                    const sliderNavigationLetters = document.querySelectorAll('span[data-slide]');
                    const navigationLettersCount = sliderNavigationLetters.length;
                    sliderNavigationLetters.forEach(function (element) {
                        element.addEventListener('click', function () {
                            const slideInt = parseInt(element.dataset.slide) + 1;
                            const slide = slideInt < navigationLettersCount - 3 ? slideInt : navigationLettersCount - 3;
                            $('.brands-slider').slick('slickGoTo', slide);
                        });
                    });
                }

                if (dropdownOverlay !== null) {
                    otherDropdownOverlays.forEach(function (otherDropdownOverlay) {
                        otherDropdownOverlay.classList.remove('active');
                    });
                    otherDropdownButtons.forEach(function (otherDropdownButton) {
                        otherDropdownButton.classList.remove('active');
                    });
                    const header = document.querySelector('.header');
                    if (header !== null) {
                        const dropDownMaxHeight = window.innerHeight - header.offsetHeight;
                        dropdownOverlay.style.maxHeight = dropDownMaxHeight + 'px';
                    }
                    element.classList.add('active');
                    dropdownOverlay.classList.add('active');

                    element.addEventListener('mouseleave', function () {
                        setTimeout(function () {
                            function checkItemUnderCursor(event) {
                                const dropdownButton = event.target.closest('.dropdown');
                                const dropdownContent = event.target.closest('.dropdown-overlay');

                                if (!dropdownButton && !dropdownContent) {
                                    element.classList.remove('active');
                                    dropdownOverlay.classList.remove('active');
                                    document.removeEventListener('mousemove', checkItemUnderCursor);
                                }
                            }

                            document.addEventListener('mousemove', checkItemUnderCursor);
                        }, 1000);
                    });
                }
            });
        });

        document.addEventListener('click', function (event) {
            const openDropdown = document.querySelector('.dropdown-overlay.active');
            if (openDropdown !== null && !event.target.closest('.dropdown-overlay') && !event.target.closest('.dropdown')) {
                const openDropdownButton = document.querySelector('.dropdown.active');
                openDropdown.classList.remove('active');
                openDropdownButton.classList.remove('active');
            }
        });
    }

    Header.prototype.initMiniCartButtons = function () {
        const miniCartButtons = document.querySelectorAll('.mini-cart-button');
        miniCartButtons.forEach(function (element) {
            element.addEventListener('click', function () {
                const miniCart = document.querySelector('.mini-cart');
                if (miniCart !== null) {
                    const miniCartCloseButton = document.querySelector('.mini-cart .close-icon');
                    if (miniCartCloseButton !== null) {
                        miniCartCloseButton.addEventListener('click', function () {
                            miniCart.classList.remove('active');
                            miniCartCloseButton.classList.remove('active');
                            document.body.classList.remove('no-scroll-mobile');
                        });
                    }

                    const isDesktop = window.innerWidth > 768;
                    if (isDesktop) {
                        const header = document.querySelector('.header');
                        const headerTopBar = document.querySelector('.header .top');
                        const headerMain = document.querySelector('.header .main');

                        const headerItemsSet = (
                            header !== null
                            && headerTopBar !== null
                            && headerMain !== null
                        );

                        if (headerItemsSet) {
                            const topBarActivatedOnShrink = (
                                headerTopBar.classList.contains('shrink')
                                && headerTopBar.classList.contains('always-on')
                            );
                            const topBarShrinked = headerTopBar.classList.contains('shrink');

                            if (topBarActivatedOnShrink) {
                                const headerHeight = header.offsetHeight;
                                const miniCartMaxHeight = (window.innerHeight - headerHeight);
                                miniCart.style.top = headerHeight + 'px';
                                miniCart.style.maxHeight = miniCartMaxHeight + 'px';
                            } else if (topBarShrinked) {
                                const headerMainHeight = headerMain.offsetHeight;
                                const miniCartMaxHeight = (window.innerHeight - headerMainHeight);
                                miniCart.style.top = headerMainHeight + 'px';
                                miniCart.style.maxHeight = miniCartMaxHeight + 'px';
                            } else {
                                const headerTopBarHeight = headerTopBar.offsetHeight;
                                const miniCartMaxHeight = (window.innerHeight - headerTopBarHeight);
                                miniCart.style.top = headerTopBarHeight + 'px';
                                miniCart.style.maxHeight = miniCartMaxHeight + 'px';
                            }
                        }
                    }

                    miniCart.classList.toggle('active');
                    if (element.classList.contains('original-mini-cart-button')) {
                        element.classList.toggle('active');
                    }
                    document.body.classList.toggle('no-scroll-mobile');

                    document.addEventListener('click', function (event) {
                        if (miniCart.classList.contains('active') && !event.target.closest('.mini-cart') && !event.target.closest('.mini-cart-button')) {
                            miniCart.classList.remove('active');
                            if (element.classList.contains('original-mini-cart-button')) {
                                element.classList.remove('active');
                            }
                        }
                    });


                }
            });
        });
    }

    Header.prototype.initMobileMenu = function () {
        const mobileMenuButton = document.querySelector('.mobile-menu-button');
        if (mobileMenuButton !== null) {
            mobileMenuButton.addEventListener('click', function () {
                const mobileMenu = document.querySelector('.mobile-menu.main-menu');
                if (mobileMenu !== null) {
                    const mobileMenuCloseButton = document.querySelector('.mobile-menu.main-menu .close-icon');
                    if (mobileMenuCloseButton !== null) {
                        mobileMenuCloseButton.addEventListener('click', function () {
                            mobileMenu.classList.remove('active');
                            document.body.classList.remove('no-scroll-mobile');
                        });
                    }
                    mobileMenu.classList.add('active');
                    document.body.classList.add('no-scroll-mobile');
                }
            });

            const mobileSubmenuButtons = document.querySelectorAll('.mobile-menu .link[data-submenu-id]');
            mobileSubmenuButtons.forEach(function (element) {
                element.addEventListener('click', function () {
                    const mobileSubmenuId = element.dataset.submenuId;
                    const mobileSubmenu = document.querySelector('.mobile-menu.submenu[data-submenu="' + mobileSubmenuId + '"]');
                    if (mobileSubmenu !== null) {
                        const mobileSubmenuCloseButton = mobileSubmenu.querySelector('.close-icon');
                        if (mobileSubmenuCloseButton !== null) {
                            mobileSubmenuCloseButton.addEventListener('click', function () {
                                mobileSubmenu.classList.remove('active');
                            });
                        }
                        mobileSubmenu.classList.add('active');
                    }
                });
            });
        }
    }

    Header.prototype.initStickyHeader = function () {
        document.addEventListener('scroll', function () {
            const headerTop = document.querySelector('.header .top');
            const headerMain = document.querySelector('.header .main');
            const headerMobileMain = document.querySelector('.header .mobile-main');
            const mobileNavItems = document.querySelector('.header .mobile-main .nav-items');
            const mobileSearchField = document.querySelector('.header .mobile-main .input-search');
            const mobileSearchInput = document.querySelector('.header .mobile-main .input-search input');
            const originalMiniCartButton = document.querySelector('.header .top .original-mini-cart-button');
            const shrinkedMiniCartButton = document.querySelector('.header .main .shrinked-mini-cart-button');
            const topBarToggle = document.querySelector('.header .main .top-bar-toggle');

            const coreElementsExist = (
                headerTop !== null
                && headerMain !== null
            );

            const allElementsExist = (
                headerTop !== null
                && headerMain !== null
                && mobileNavItems !== null
                && mobileSearchField !== null
                && mobileSearchInput !== null
                && originalMiniCartButton !== null
                && shrinkedMiniCartButton !== null
                && topBarToggle !== null
            );

            if (coreElementsExist) {
                if (window.scrollY > 132) {
                    headerTop.classList.add('shrink');
                    headerMain.classList.add('shrink');
                    headerMobileMain.classList.add('shrink');
                } else {
                    headerTop.classList.remove('shrink');
                    headerMain.classList.remove('shrink');
                    headerMobileMain.classList.remove('shrink');
                }
            }

            if (allElementsExist) {
                if (window.scrollY > 132) {
                    // mobileNavItems.classList.add('shrink');
                    // mobileSearchField.classList.add('shrink');
                    // mobileSearchInput.classList.add('shrink');
                    originalMiniCartButton.classList.add('hidden');
                    shrinkedMiniCartButton.classList.add('active');
                    topBarToggle.classList.add('active');
                } else {
                    // mobileNavItems.classList.remove('shrink');
                    // mobileSearchField.classList.remove('shrink');
                    // mobileSearchInput.classList.remove('shrink');
                    originalMiniCartButton.classList.remove('hidden');
                    shrinkedMiniCartButton.classList.remove('active');
                    topBarToggle.classList.remove('active');
                }
            }
        });
    }

    Header.prototype.initLangDropdowns = function () {
        const langButton = document.querySelector('.header .top .lang-button');
        if (langButton !== null) {
            langButton.addEventListener('click', function (element) {
                const langDropdown = document.querySelector('.header .top .lang-dropdown');
                if (langDropdown !== null) {
                    langButton.classList.toggle('active');
                    langDropdown.classList.toggle('active');
                }
            });
        }

        const mobileLangButton = document.querySelector('.header .mobile-main .lang-button');
        if (mobileLangButton !== null) {
            mobileLangButton.addEventListener('click', function (element) {
                const mobileLangDropdown = document.querySelector('.header .mobile-main .lang-dropdown');
                if (mobileLangDropdown !== null) {
                    mobileLangButton.classList.toggle('active');
                    mobileLangDropdown.classList.toggle('active');
                }
            });
        }
    }

    Header.prototype.initTopBarToggle = function () {
        const topBarToggle = document.querySelector('.header .top-bar-toggle');
        const topBarIcons = document.querySelectorAll('.header .top-bar-toggle .icon');
        if (topBarToggle !== null) {
            topBarToggle.addEventListener('click', function (element) {
                const topBar = document.querySelector('.header .top');
                if (topBar !== null) {
                    topBar.classList.toggle('always-on');
                    topBarIcons.forEach(function (element) {
                        element.classList.toggle('active');
                    });
                }
            });
        }
    }

    Header.prototype.initProfileMenu = function () {
        const profileMenuToggle = document.querySelector('.header .profile-dropdown .dropdown-toggle');
        if (profileMenuToggle) {
            const profileMenuContent = profileMenuToggle.parentNode.querySelector('.dropdown-content');
            if (profileMenuContent) {
                profileMenuToggle.addEventListener('click', function () {
                    profileMenuToggle.classList.toggle('active');
                    profileMenuContent.classList.toggle('active');

                    document.addEventListener('click', function (event) {
                        if (profileMenuContent.classList.contains('active') && !event.target.closest('.profile-dropdown')) {
                            profileMenuToggle.classList.remove('active');
                            profileMenuContent.classList.remove('active');
                        }
                    });
                });
            }
        }
    }

    Header.prototype.initMobileProfileMenu = function () {
        const mobileProfileMenuToggle = document.querySelector('.header .mobile-profile-dropdown .dropdown-toggle');
        const mobileProfileMenuContent = mobileProfileMenuToggle ? mobileProfileMenuToggle.parentNode.querySelector('.dropdown-content') : null;
        const mobileProfileMenuCloseButton = mobileProfileMenuContent ? mobileProfileMenuContent.querySelector('.close-icon') : null;
        if (mobileProfileMenuToggle && mobileProfileMenuContent && mobileProfileMenuCloseButton) {
            mobileProfileMenuToggle.addEventListener('click', function () {
                mobileProfileMenuCloseButton.addEventListener('click', function () {
                    mobileProfileMenuContent.classList.remove('active');
                    document.body.classList.remove('no-scroll-mobile');
                });
                mobileProfileMenuContent.classList.add('active');
                document.body.classList.add('no-scroll-mobile');
            });
        }
    }

    Header.prototype.initAdjustOnScroll = function () {
        const header = document.querySelector('.header');
        const headerTopBar = document.querySelector('.header .top');
        const profileMenuToggle = document.querySelector('.header .profile-dropdown .dropdown-toggle');
        const profileMenuContent = profileMenuToggle ? profileMenuToggle.parentNode.querySelector('.dropdown-content') : null;

        document.addEventListener('scroll', function () {
            if (
                profileMenuToggle && profileMenuToggle.classList.contains('active')
                && profileMenuContent && profileMenuContent.classList.contains('active')
                && headerTopBar && headerTopBar.classList.contains('shrink') && !headerTopBar.classList.contains('always-on')
            ) {
                profileMenuToggle.classList.remove('active');
                profileMenuContent.classList.remove('active');
            }
        });
    }

    return Header;
}(window, document));
